//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins'
import Complaint from '@/components/Complaint'
import { GlobalApi } from '@/api'

export default {
  name: 'My',
  mixins: [mixin],
  components: {
    Complaint
  },
  data() {
    return {
      productConfig: [],
      showFollowDialog: false
    }
  },
  computed: {
    productConfigMap() {
      return new Map([...this.productConfig.map(item => [item.key, item.value])])
    }
  },
  created() {
    this.getProductConfig();

      let appType = this.$route.query.appType
     console.log("获取的地址栏的appType是"+appType);

  },
  methods: {
    getProductConfig() {
      GlobalApi.getDicInfoByKey({ key: 'productConfig' }).then(data => {
        if (data.Status === 200) {
          this.productConfig = data.Result instanceof Array ? data.Result : []
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/My.vue